import './App.css';
import AllRoutes from './Routes/AllRoutes';

function App() {


  return (
    <div className="App">
        <AllRoutes /> 
    </div>
  );
}

export default App;
